import { Component, OnInit } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { RouterLink } from '@angular/router';
import { CustomizerSettingsService } from '../../customizer-settings/customizer-settings.service';
import { SampleService } from '../../services/sample-service/sample.service';

@Component({
    selector: 'app-total-orders',
    standalone: true,
    imports: [MatCardModule, RouterLink],
    templateUrl: './total-orders.component.html',
    styleUrl: './total-orders.component.scss'
})
export class TotalOrdersComponent implements OnInit{

    // isToggled
    isToggled = false;
    totalOt = 0
 ngOnInit(): void {
     this.getTotalOT()
 }
    constructor(
        public themeService: CustomizerSettingsService,
        private sampleService:SampleService
    ) {
        this.themeService.isToggled$.subscribe(isToggled => {
            this.isToggled = isToggled;
        });
    }

    private getTotalOT(){
        this.sampleService.getSampleStatusCount().subscribe(statusCount => {
            this.totalOt = statusCount['Avec OT']; 
          });
    }
    // Dark Mode
    toggleTheme() {
        this.themeService.toggleTheme();
    }

}